import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DemographicsDataProviders } from '~/store/demographics/demographics.types';
import { demographicsListPremiumFetchDataRequest } from '~/store/demographics/premiumDemographics/demographicsListPremium.actionCreators';
import {
  useActivePremiumDemographicsSelector,
  useDemographicsListPremiumIsLoadedSelector, useDemographicsListPremiumIsLoadingSelector,
  useDemographicsListPremiumRegionSelector,
} from '~/store/demographics/premiumDemographics/demographicsListPremium.selectors';

export const usePremiumDemographicsList = () => {
  const dispatch = useDispatch();
  const isLoading = useDemographicsListPremiumIsLoadingSelector();
  const isFetched = useDemographicsListPremiumIsLoadedSelector();
  const agsData = useDemographicsListPremiumRegionSelector(DemographicsDataProviders.AGS);
  const agsDataPurchased = useActivePremiumDemographicsSelector(DemographicsDataProviders.AGS).purchased;

  useEffect(() => {
    if (!isFetched && !isLoading) {
      dispatch(demographicsListPremiumFetchDataRequest());
    }
  }, [dispatch, isFetched, isLoading]);

  return {
    isLoading,
    agsData,
    agsDataPurchased,
  };
};
